import React from 'react';
import { Button, type ButtonProps } from 'antd';
import type { ChargeBeePlanId } from '@prerender/billing-shared';

import { UpgradePlanProvider, useUpgradePlan } from '~features/UpgradePlan';

export const SEARCH_PERFORMANCE_PLAN_COPY = {
  notIncluded: (planName: string) =>
    `Search Performance isn't part of ${planName}. Upgrade to Pro to sync your first domain and see how the pages Prerender serves actually perform in Google Search.`,
  upgradeToPro: 'Upgrade to Pro',
  proAtCap:
    'Your Pro plan syncs one domain. Enterprise raises that to five, so you can add staging, a regional site, or a second brand alongside this one.',
  upgradeToEnterprise: 'Upgrade to Enterprise',
  cancelled: (planName: string, endedOn: string | null) =>
    `Your ${planName} plan ended${
      endedOn ? ` on ${endedOn}` : ''
    }. Search Performance is paused until you reactivate your plan.`,
  contactAccountOwner: 'Please contact your Account Owner.',
  reactivate: (planName: string) => `Reactivate ${planName} Plan`,
  manageSubscription: 'Manage subscription',
} as const;

type Props = Pick<ButtonProps, 'type' | 'icon' | 'block' | 'size' | 'style'> & {
  targetPlanId: ChargeBeePlanId;
  ctaLocation: string;
  ctaName: string;
};

function UpgradeButton({
  targetPlanId,
  ctaLocation,
  ctaName,
  children,
  ...buttonProps
}: React.PropsWithChildren<Props>) {
  const { openUpgradePlan } = useUpgradePlan();

  // A plain Button, not ButtonWithRole: `openUpgradePlan` already routes
  // non-managers to the "ask an admin" modal instead of the plans page.
  return (
    <Button {...buttonProps} onClick={() => openUpgradePlan(undefined, targetPlanId, { ctaLocation, ctaName })}>
      {children}
    </Button>
  );
}

function SearchPerformanceUpgradeCta(props: React.PropsWithChildren<Props>) {
  return (
    <UpgradePlanProvider>
      <UpgradeButton {...props} />
    </UpgradePlanProvider>
  );
}

export default SearchPerformanceUpgradeCta;
